module.exports = __webpack_public_path__ + "media/audio42.4292fa74.mp3";